import React from 'react';
import _ from 'lodash';
import {Header, Icon} from 'semantic-ui-react';
import PropTypes from 'prop-types';

const TgHeader = ({model}) => (
    <div>
        <Header as='h2'>
            <Icon name='settings' />
            <Header.Content>
                TradeGecko
                <Header.Subheader>Privileged Token: {model.key_1}</Header.Subheader>
                <Header.Subheader>Last Synchronize: {_.isObject(model.synchronize) ? model.synchronize.updated_at : null}</Header.Subheader>
            </Header.Content>
        </Header>
    </div>
)

TgHeader.propTypes = {
    model: PropTypes.object.isRequired
};


export default TgHeader